<div class="project-address-left" *ngIf="!readOnly">
    <agm-map *ngIf="mapReady && location.lat" [(latitude)]="location.lat" [(longitude)]="location.lng" [(zoom)]="location.zoom"
             [streetViewControl]="false"
             [disableDefaultUI]="true" [zoomControl]="false" [fitBounds]='fitBounds'
             [mapTypeId]="toggleTypeMap ? 'roadmap' : 'satellite'">
        <agm-marker [(latitude)]="location.marker.lat" [(longitude)]="location.marker.lng"
                    [markerDraggable]="location.marker.draggable" [agmFitBounds]="true"
                    (dragEnd)='markerDragEnd($event)'>
            <agm-info-window *ngIf="project?.name" [isOpen]="true">{{project?.name}}</agm-info-window>
        </agm-marker>
    </agm-map>
    <div>Zoom
        <mat-slider style="width:70%" min="1" max="20" step="1" tickInterval="1" [(value)]="location.zoom" thumbLabel
        ></mat-slider>
        <mat-slide-toggle [(ngModel)]="toggleTypeMap">View Type</mat-slide-toggle>
    </div>
</div>

<div [ngClass]="readOnly ? 'project-address-right project-address-right-read-only' : 'project-address-right'">
    <div *ngIf="readOnly">
        <b [innerHtml]="'ADDRESS'|translate">Address</b>
        <app-button-project-edit *ngIf="!disableEditionButton" [selectedStep]="1"></app-button-project-edit>
    </div>

    <form [formGroup]="projectAddressForm" *ngIf="projectAddressForm">
        <mat-form-field [ngClass]="readOnly ? 'readonly' : ''">
            <input matInput [placeholder]="'ADDRESS1' | translate" formControlName="place" [readonly]="readOnly">
        </mat-form-field>
        <mat-form-field [ngClass]="readOnly ? 'readonly' : ''">
            <input matInput [placeholder]="'ADDRESS2' | translate" formControlName="street" [readonly]="readOnly">
        </mat-form-field>
        <mat-form-field [ngClass]="readOnly ? 'readonly' : ''">
            <input matInput [placeholder]="'ZIPCODE' | translate" formControlName="zipcode" [readonly]="readOnly">
        </mat-form-field>
        <mat-form-field [ngClass]="readOnly ? 'readonly' : ''">
            <input matInput [placeholder]="'CITY' | translate" formControlName="city" [readonly]="readOnly">
        </mat-form-field>
        <mat-form-field [ngClass]="readOnly ? 'readonly' : ''">
            <input matInput [placeholder]="'COUNTRY' | translate" formControlName="country" [readonly]="readOnly">
        </mat-form-field>
        <br/>
        <mat-form-field style="width:90%" [ngClass]="readOnly ? 'readonly' : ''">
            <input matInput [placeholder]="'NOTES' | translate" formControlName="supplement" [readonly]="readOnly">
        </mat-form-field>

    </form>
    <div style="margin-left:20px" *ngIf="!readOnly">
        <button type="button" class="btn btn-warning" (click)="updateOnMap()">
            <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
            {{'ACCEPT'|translate}}
        </button>
        <button (click)='resetMap()' type="submit" class="btn btn-primary"> {{'RESET'|translate}}</button>
    </div>

</div>

<br clear="left"/>
